export enum BotDetectionTemplateSensitivity {
  Off,
  Low,
  Medium,
  High,
  Custom,
}
